/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable import/order */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import Scrollbar from 'react-smooth-scrollbar';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import SidebarContent from './SidebarContent';
import { SidebarProps } from '../../../shared/prop-types/ReducerProps';
import img from '../../../shared/img/logo/logo.png';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import SidebarContentTeacher from './SidebarContentTeacher';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    'z-index': '99',
  },
  BottomBar: {
    top: 'auto',
    color: 'white',
    height: 100,
    backgroundColor: '#282828',
    bottom: 0,
    zIndex: theme.zIndex.drawer + 1,
  },

  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  itemToolBar: {
    color: 'white',
  },
  sidebarTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logo: {
    height: '40px',
    width: '50px',
    marginLeft: '10px',
  },
}));

const Sidebar = ({
  changeMobileSidebarVisibility, changeSidebarVisibility, sidebar, user, color,
}) => {
  const sidebarClass = classNames({
    sidebar: true,
    'sidebar--show': sidebar.show,
    'sidebar--collapse': sidebar.collapse,
  });

  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const backgroundColor = '#FFF';
  const backgroundColorTop = '#FFF';

  return (
    <div style={{ backgroundColor, zIndex: 1200 }} className={sidebarClass}>
      <div className={classes.toolbar} style={{ backgroundColor: backgroundColorTop }}>
        {!sidebar.collapse && <img className={classes.logo} src={img} alt="EW" />}
        <IconButton onClick={changeSidebarVisibility}>
          {sidebar.collapse
            ? <ChevronRightIcon />
            : <ChevronLeftIcon />}
        </IconButton>
      </div>
      <Divider />
      <button type="button" className="sidebar__back" onClick={changeSidebarVisibility} aria-label="sidebar back" />
      <Scrollbar className="sidebar__scroll scroll">
        <div className="sidebar__wrapper sidebar__wrapper--desktop">
          {user.type === 1
            ? (
              <SidebarContent
                onClick={() => { }}
                color={color}
                user={user}
              />
            )
            : (
              <SidebarContentTeacher
                onClick={() => { }}
                color={color}
                user={user}
              />
            )}
        </div>
        <div className="sidebar__wrapper sidebar__wrapper--mobile">
          {user.type === 1
            ? (
              <SidebarContent
                onClick={() => changeMobileSidebarVisibility}
                color={color}
                user={user}
              />
            )
            : (
              <SidebarContentTeacher
                onClick={() => changeMobileSidebarVisibility}
                color={color}
                user={user}
              />
            )}
        </div>
      </Scrollbar>
    </div>
  );
};

Sidebar.propTypes = {
  sidebar: SidebarProps.isRequired,
  user: PropTypes.any.isRequired,
  changeMobileSidebarVisibility: PropTypes.func.isRequired,
};

export default Sidebar;
